/**
 * Tiny recharts palette for the audience-voting histogram — the only chart in
 * this repo that uses a chart library (the field/capacity screens are ported
 * imperative SVG). Derived from `features/views/colors.ts` so the histogram
 * reads as part of this repo's palette rather than inventing a second one.
 */

import { GRID_LINE, INK, NEUTRAL } from "@/features/views/colors";

/** J&J red — reserved for the single emphasized bar (the tallest bucket). */
export const EMPHASIS = "#EB1700";
/** De-emphasized bars — everything that isn't the max bucket. */
export const SUPPORTING = [NEUTRAL, NEUTRAL];
export const GRID = GRID_LINE;

export const AXIS_TICK = { fontSize: 11, fill: INK };
export const TOOLTIP_STYLE = {
  fontSize: 12,
  borderRadius: 6,
  border: `1px solid ${GRID_LINE}`,
  boxShadow: "none",
};
